const SECCION_COBERTURA = {
   2: 'ART',
   4: 'Caución',
   8: 'Hipoteca',
   9: 'Responsabilidad Civil',
};

const normalizeSeccionKey = (id_seccion) => {
   if (id_seccion === null || id_seccion === undefined || id_seccion === '') {
      return null;
   }

   const asNumber = Number(id_seccion);
   if (Number.isFinite(asNumber) && SECCION_COBERTURA[asNumber]) {
      return asNumber;
   }

   const normalized = String(id_seccion).trim().toUpperCase();
   if (normalized === 'ART') return 2;
   if (normalized === 'CAUCIÓN' || normalized === 'CAUCION') return 4;
   if (normalized === 'HIPOTECA') return 8;
   if (normalized === 'RESPONSABILIDAD CIVIL') return 9;

   return null;
};

const getCoberturaNombre = (id_seccion) => {
   const seccionKey = normalizeSeccionKey(id_seccion);
   if (seccionKey) {
      return SECCION_COBERTURA[seccionKey];
   }

   if (typeof id_seccion === 'string' && id_seccion.trim()) {
      return id_seccion.trim();
   }

   return 'Caución';
};

const bodyEmail = (usuario, id_seccion) => ({
   asunto: null,
   cuerpo: `<p>Estimados/as,</p>
<p>
Por medio de la presente, solicitamos cotización para la cobertura de ${getCoberturaNombre(
      id_seccion,
   )} para un cliente interesado en evaluar opciones disponibles en el mercado.
</p>
<p>Se adjuntan los documentos necesarios para la elaboración de la propuesta.</p>
<p>
Quedamos a disposición para cualquier información adicional que puedan necesitar.
</p>
<p>
<strong>Saludos cordiales,</strong><br>
${usuario.usuario}<br>
${usuario.email}
</p>`,
});

export { bodyEmail, getCoberturaNombre };
